import type { MenuTreeNode } from '@axsolutionsdev/shared';
import type { AxiosInstance } from 'axios';

/**
 * BE 의 GET /api/menus/tree 응답 형상.
 *
 * `MenuTreeNode` 는 BE↔FE 공유 타입으로 `@axsolutionsdev/shared` 에 정의된다 (I.1).
 *
 * R4.B.2 (M.2) 이후: BE 가 `MenuTreeNode[]` 배열을 직접 return 하고
 * ResponseEnvelopeInterceptor 가 `{ data: [...] }` 로 wrap. FE 의 `client.ts`
 * unwrap 인터셉터가 이를 풀어 `res.data` 가 곧 `MenuTreeNode[]`.
 */
export type { MenuTreeNode } from '@axsolutionsdev/shared';

export async function fetchMenuTree(client: AxiosInstance): Promise<MenuTreeNode[]> {
  const { data } = await client.get<MenuTreeNode[]>('/menus/tree');
  return data;
}
